import type { HighlightRange } from '../../api/catalog.ts';

export interface TextSegment {
  text: string;
  matched: boolean;
}

/**
 * Cuts `text` into matched/unmatched runs from `catalog.ts`'s `highlightRanges()` (AC-UI-3
 * "highlighted matches"). Pure — kept in its own `.ts` module (no JSX) so `node --test` can run
 * it directly; `Highlighted.tsx` is the one-line rendering wrapper around this. Ranges are
 * assumed sorted and non-overlapping, exactly what `highlightRanges()` produces (a left-to-right
 * scan for one query string).
 */
export function splitHighlightSegments(text: string, ranges: readonly HighlightRange[]): TextSegment[] {
  if (ranges.length === 0) return [{ text, matched: false }];
  const segments: TextSegment[] = [];
  let cursor = 0;
  for (const range of ranges) {
    if (range.start > cursor) segments.push({ text: text.slice(cursor, range.start), matched: false });
    segments.push({ text: text.slice(range.start, range.end), matched: true });
    cursor = range.end;
  }
  if (cursor < text.length) segments.push({ text: text.slice(cursor), matched: false });
  return segments;
}
